// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) 2025 Robert Schiwon
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

sf-app {
  display: flex;
  flex-direction: column;
  /* fill 100% height */
  height: calc(100% - 0.5em);
  margin: 0.25em;
}

/* header - content - footer */

sf-app > .header {
  background-color: #eee;
  height: 2em;
}

sf-app > .content {
  background-color: #eee;
  display: flex;
  /* fill 100% height */
  height: calc(100% - 2em - 2em);
  gap: 0.25em;
}

sf-app > .footer {
  background-color: #eee;
  height: 2em;
}

/* content */

sf-app > .content > .tree {
  background-color: #eee;
  display: flex;
  flex: 0 0 20%;
  white-space: nowrap;
  overflow: auto;
}

sf-app > .content > .node-content {
  background-color: #eee;
  flex: 0 1 80%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 0.25em;
}

sf-app > .content > .node-content > .data {
  background-color: #eee;
  flex: 0 0 60%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

sf-app > .content > .node-content > .params {
  background-color: #eee;
  flex: 0 1 40%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

/* mobile */

@media screen and (max-width: 576px) {
  sf-app > .content {
    flex-direction: column;
  }
  sf-app > .content > .tree {
    flex: 0 0 30%;
    flex-direction: column;
  }

  sf-app > .content > .node-content {
    flex: 0 1 70%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,8BAA8B;;AAE9B;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA,YAAY;;AAEZ;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA,WAAW;;AAEX;EACE;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/**\n * Copyright (c) 2025 Robert Schiwon\n *\n * Permission is hereby granted, free of charge, to any person obtaining a copy of\n * this software and associated documentation files (the \"Software\"), to deal in\n * the Software without restriction, including without limitation the rights to\n * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n * the Software, and to permit persons to whom the Software is furnished to do so,\n * subject to the following conditions:\n *\n * The above copyright notice and this permission notice shall be included in all\n * copies or substantial portions of the Software.\n *\n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n */\n\nsf-app {\n  display: flex;\n  flex-direction: column;\n  /* fill 100% height */\n  height: calc(100% - 0.5em);\n  margin: 0.25em;\n}\n\n/* header - content - footer */\n\nsf-app > .header {\n  background-color: #eee;\n  height: 2em;\n}\n\nsf-app > .content {\n  background-color: #eee;\n  display: flex;\n  /* fill 100% height */\n  height: calc(100% - 2em - 2em);\n  gap: 0.25em;\n}\n\nsf-app > .footer {\n  background-color: #eee;\n  height: 2em;\n}\n\n/* content */\n\nsf-app > .content > .tree {\n  background-color: #eee;\n  display: flex;\n  flex: 0 0 20%;\n  white-space: nowrap;\n  overflow: auto;\n}\n\nsf-app > .content > .node-content {\n  background-color: #eee;\n  flex: 0 1 80%;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  gap: 0.25em;\n}\n\nsf-app > .content > .node-content > .data {\n  background-color: #eee;\n  flex: 0 0 60%;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n\nsf-app > .content > .node-content > .params {\n  background-color: #eee;\n  flex: 0 1 40%;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n\n/* mobile */\n\n@media screen and (max-width: 576px) {\n  sf-app > .content {\n    flex-direction: column;\n  }\n  sf-app > .content > .tree {\n    flex: 0 0 30%;\n    flex-direction: column;\n  }\n\n  sf-app > .content > .node-content {\n    flex: 0 1 70%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
